import styled from 'styled-components';
import { Grid} from '@material-ui/core';

export const GridContainer = styled(Grid)`
    padding: 10px 10px 10px 0px;
    border : 1px solid black;
    border-radius: 25px;
    margin-bottom: 20px;
`;

export const GridItem = styled(Grid)`
    padding-left: 10px;
`;

export const LicenseImage = styled.img`
    max-width: 100%
`;